<template>
  <div
    class="layout"
    :class="[computedCharacterColorClass]"
  >
    <!-- 梵字・家紋 + 俗名の表記（ラベル） + 俗名 -->
    <div
      class="main"
      :class="{
        adjust: isBackSymbolAvailable,
        other: secularNamePrefix.length,
      }"
    >
      <!-- 梵字・家紋 -->
      <div>
        <div
          v-if="isBackSymbolAvailable"
          class="symbol flex center"
        >
          <div class="box">
            <ImageResolver
              :src="computedBackSymbolSrc"
              class="character"
            />
          </div>
        </div>
      </div>

      <!-- 俗名の表記（ラベル） -->
      <div
        class="secularNamePrefixes"
        :class="{
          adjust: secularNamePrefix.length,
        }"
      >
        <!-- 俗名の表記（ラベル） > 霊ごと -->
        <template v-if="secularNamePrefixPlacement === 'EACH_COLUMN'">
          <div
            v-for="target in ['left', 'right']"
            :key="`secular-name-prefix-${target}`"
            class="secularNamePrefix flex center column"
            :class="{
              left: target === 'left',
              right: target === 'right',
            }"
          >
            <!-- 俗名の表記（ラベル） -->
            <TabletCharacterImage
              v-for="(character, index) in secularNamePrefix"
              :key="`character-${character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...secularNamePrefixPayload,
                characterIndex: index,
                columnIndex: null,
                ...$event,
              })"
            />
          </div>
        </template>

        <!-- 俗名の表記（ラベル） > 中心 -->
        <template v-if="secularNamePrefixPlacement !== 'EACH_COLUMN'">
          <div class="secularNamePrefix flex center column">
            <!-- 俗名の表記（ラベル） -->
            <TabletCharacterImage
              v-for="(character, index) in secularNamePrefix"
              :key="`character-${character}-${index}`"
              :char="character"
              :font="typography.font"
              :size="computedCharacterSize"
              @onClickCharacter="onClickCharacter({
                ...secularNamePrefixPayload,
                characterIndex: index,
                columnIndex: null,
                ...$event,
              })"
            />
          </div>
        </template>
      </div>

      <!-- スペーサー（0px or 15px） -->
      <div />

      <!-- 俗名 -->
      <div class="secularNames">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`secularName-${column.order}`"
          class="secularName flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 俗名 -->
          <TabletCharacterImage
            v-for="(character, index) in column.secularName"
            :key="`character-${character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...secularNamePayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- スペーサー -->
      <div />
    </div>

    <!-- 左側: 享年表記 + 没年齢 + 没年齢単位 -->
    <div class="side">
      <!-- シンボル分のスペーサー -->
      <div />

      <!-- スペーサー -->
      <div />

      <!-- 享年表示 -->
      <div class="ageAtDeathPrefixes">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageAtDeathPrefix-${column.order}`"
          class="ageAtDeathPrefix flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 享年表記 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageAtDeathPrefix"
            :key="`ageAtDeathPrefix-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPrefixPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 没年齢 -->
      <div class="ageAtDeaths">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageAtDeath-${column.order}`"
          class="ageAtDeath flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <!-- 没年齢 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageAtDeath"
            :key="`ageAtDeath-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageAtDeathPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event,
            })"
          />
        </div>
      </div>

      <!-- 没年齢単位 -->
      <div class="ageUnitCharacters">
        <div
          v-for="(column, columnIndex) in columns"
          :key="`ageUnitCharacter-${column.order}`"
          class="ageUnitCharacter flex align-center column justify-space-between"
          :class="{
            left: column.order === 2,
            right: column.order === 1,
          }"
        >
          <div class="box grow" />
          <!-- 没年齢単位 -->
          <TabletCharacterImage
            v-for="(character, index) in column.ageUnitCharacter"
            :key="`ageUnitCharacter-${character.character}-${index}`"
            :char="character"
            :font="typography.font"
            :size="computedSideCharacterSize"
            @onClickCharacter="onClickCharacter({
              ...ageUnitCharacterPayload,
              characterIndex: index,
              columnIndex: columnIndex,
              ...$event
            })"
          />
        </div>
      </div>

      <!-- スペーサー -->
      <div />
    </div>
  </div>
</template>

<script>
import TabletPreviewMixin from "@/mixins/tabletPreview.mixin";

export default {
  mixins: [
    TabletPreviewMixin.back,
    TabletPreviewMixin.character,
  ],
  data () {
    return {
    };
  },
  computed: {
    // 俗名の表記（ラベル）+ 俗名
    // の文字列の長さから要素一つあたりのサイズを算出
    computedCharacterSize () {
      const {
        columns,
        secularNamePrefix,
      } = this;

      const defaultSize = 25;
      const gap = secularNamePrefix.length ? 10 : 0;
      const maxHeight = 320 - 15 - 15 - gap;

      const rightCharacterLength = columns[0].secularName.length + secularNamePrefix.length;
      const leftCharacterLength = columns[1].secularName.length + secularNamePrefix.length;
      const characterLength = Math.max(rightCharacterLength, leftCharacterLength);
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },

    // 享年表記 + 没年齢 + 没年齢単位
    // の文字列の長さから要素一つあたりのサイズを算出
    computedSideCharacterSize () {
      const { columns } = this;

      const defaultSize = 20;
      const maxHeight = 320 - 25 - 15 - 15;
      const rightAgeUnitCharacterLength = columns[0].ageUnitCharacter ? columns[0].ageUnitCharacter.length : 0;
      const leftAgeUnitCharacterLength = columns[1].ageUnitCharacter ? columns[1].ageUnitCharacter.length : 0;
      const ageUnitCharacterLength = Math.max(rightAgeUnitCharacterLength, leftAgeUnitCharacterLength);
      const rightAgeDeathPrefix = columns[0].ageAtDeathPrefix ? columns[0].ageAtDeathPrefix.length : 0;
      const leftAgeDeathPrefix = columns[1].ageAtDeathPrefix ? columns[1].ageAtDeathPrefix.length : 0;
      const rightCharacterLength = rightAgeDeathPrefix + columns[0].ageAtDeath.length + ageUnitCharacterLength;
      const leftCharacterLength = leftAgeDeathPrefix + columns[1].ageAtDeath.length + ageUnitCharacterLength;
      const characterLength = Math.max(rightCharacterLength, leftCharacterLength);
      const characterSize = maxHeight / characterLength;
      const size = Math.min(defaultSize, characterSize);

      return size;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";

.layout {
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;

  .main {
    display: grid;
    grid-template-rows: 80px auto 0px auto 1fr;
    grid-template-columns: 1fr;
    height: 100%;
    width: 60px;
    position: absolute;
    top: 0;
    left: -60px;
    box-sizing: border-box;
    overflow-x: visible;
    z-index: 1;

    &.adjust {
      padding-bottom: 15px; // (80 - 50) / 2
    }

    &.other {
      grid-template-rows: 80px auto 10px auto 1fr;
    }

    @include symbol(105px); // (150 + 60) / 2

    .secularNamePrefixes,
    .secularNames {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .secularNamePrefix,
      .secularName {
        height: 100%;
        transform: translateX(105px);

        &.left {
          float: left;
        }

        &.right {
          float: right;
        }

        @include character(25px);
      }
    }
  }

  .side {
    display: grid;
    grid-template-rows: 80px 1fr auto auto auto 1fr;
    grid-template-columns: 1fr;
    gap: 5px;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding: 0 2.5px;

    .ageAtDeathPrefixes,
    .ageAtDeaths,
    .ageUnitCharacters {
      height: 100%;
      width: 100%;
      position: relative;
      box-sizing: border-box;

      .ageAtDeathPrefix,
      .ageAtDeath,
      .ageUnitCharacter {
        height: 100%;
        width: 35px;

        &.left {
          float: left;
        }

        &.right {
          float: right;
        }

        @include character(25px);
      }
    }
  }
}
</style>
